module.exports = __webpack_public_path__ + "img/aboutUs_img13.cd395c9e.svg";